module.exports = __webpack_public_path__ + "img/banner2.4eba32a7.png";